import { render } from "./resrveDetail.vue?vue&type=template&id=73f4732f&scoped=true"
import script from "./resrveDetail.vue?vue&type=script&lang=js"
export * from "./resrveDetail.vue?vue&type=script&lang=js"

import "./resrveDetail.vue?vue&type=style&index=0&id=73f4732f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f4732f"]])

export default __exports__